// @noflow
import './buttons-link.component.css';

import classnames from 'classnames';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import * as React from 'react';

LinkButton.propTypes = {
    alternate: PropTypes.bool,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    to: PropTypes.string.isRequired
};

/**
 * Represents a wrapper around a `Link` component from `react-router` so that
 * they are styled like buttons.
 *
 * alternate: whether or not to show a different style
 * className: any extra classes to append
 */
export default function LinkButton({ alternate, children, className, ...props }) {
    const linkClasses = {
        'link-button': true,
        'link-button--alternate': alternate,
        [className]: className != null
    };

    return (
        <Link {...props} className={classnames(linkClasses)}>
            {children}
        </Link>
    );
}



// WEBPACK FOOTER //
// ./src/components/widgets/buttons/link/buttons-link.component.js